import { Card, Box, CardActionArea, CardMedia, CardContent, Typography, Grid } from '@mui/material';
import machineDefaultImage from '../../../../images/machineImageEmpty.svg';
import { singleDocumentImageUrl } from '../../../../utils/imageProxy';
import ContractRenewStatus from '../../../contracts/contractRenewStatus';
import '../../../../css/machines/contractMachineGridViewData.css';
import { FormatDate } from '../../../../utils/formatDate';
import { useNavigate } from 'react-router-dom';
import Skeleton from '@mui/material/Skeleton';
import Iconify from '../../../Iconify';
import React from 'react';

const MachineContractCardViewData = React.memo(({ index, style, data }) => {

    const { contracts, columns, filteredRecordCount } = data;

    const navigate = useNavigate();
    const startIndex = index * columns;
    const endIndex = Math.min(startIndex + columns, filteredRecordCount);

    return (
        <Box style={style} key={index}>
            <Grid container spacing={2}>
                {Array.from({ length: endIndex - startIndex })?.map((_, idx) => {
                    const machineIndex = startIndex + idx;
                    const contract = contracts[machineIndex];

                    const uniqueMachineIds = new Set();

                    contract.contract_date.forEach((entry) => {
                        entry.contract_machine.forEach((machine) => {
                            uniqueMachineIds.add(machine.machine.id);
                        });
                    });                    

                    return (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={contract ? contract.id : `skeleton-${machineIndex}`}>
                            <Card className='contractMachine_gridview_card'>
                                <CardActionArea onClick={contract ? () => navigate(`/dashboard/contract/contract_details/${contract.id}`) : undefined}>
                                    {contract ? (
                                        <>
                                            <Box sx={{ position: "relative" }}>
                                                <CardMedia
                                                    component="img"
                                                    height="192"
                                                    image={singleDocumentImageUrl(contract?.company?.company_document, { fallback: machineDefaultImage })}
                                                    alt={contract.name}
                                                />
                                                {(new Date(contract.lastPeriodEndDate) < new Date() && !(new Date(contract.lastPeriodEndDate).toDateString() === new Date().toDateString())) &&
                                                    <Box
                                                        className="contractMachine_gridview_ships_box"
                                                        sx={{
                                                            position: "absolute",
                                                            top: 10,
                                                            right: 10,
                                                            backgroundColor: "white",
                                                            color: "white",
                                                            padding: "8px",
                                                            borderRadius: "4px",
                                                        }}
                                                    >
                                                        <Typography className="ships_label">Contrat inactif</Typography>
                                                    </Box>
                                                }
                                            </Box>
                                            <CardContent className='contractMachine_gridview_card_CardContent'>
                                                <Typography className='contractMachine_gridview_machine_name' component="div">{contract.company.name} x {contract.title}</Typography>
                                                <Box className='contractMachine_gridview_icon_title_response_box'>
                                                    <Iconify icon={"material-symbols:date-range-outline-rounded"} width="20px" />
                                                    <Box className='contractMachine_gridview_response_box'>
                                                        <Typography className='contractMachine_gridview_text_label'>Date :</Typography>
                                                        <Typography className='contractMachine_gridview_text_value'>{FormatDate(contract.firstPeriodStartDate)} - {FormatDate(contract.lastPeriodEndDate)}</Typography>
                                                    </Box>
                                                </Box>
                                                {new Date(contract.lastPeriodEndDate).toDateString() === new Date().toDateString() ?
                                                    <Box className='contractMachine_gridview_icon_title_response_box'>
                                                        <Iconify className='contractMachine_gridview_warning_icon' icon={"material-symbols:warning-outline"} />
                                                        <Typography className='contractMachine_gridview_warning_text'>Dernier jour !</Typography>
                                                    </Box>
                                                    :
                                                    <Box className='contractMachine_gridview_icon_title_response_box'>
                                                        <Iconify icon={"lucide:clock-fading"} width="20px" />
                                                        <Box className='contractMachine_gridview_response_box'>
                                                            <Typography className='contractMachine_gridview_text_label'>Limite d'arrêt :</Typography>
                                                            <Typography className='contractMachine_gridview_text_value'>
                                                                {new Date(contract.lastPeriodEndDate) < new Date() ? (
                                                                    // If the lastPeriodEndDate is in the past, display the lastPeriodEndDate
                                                                    FormatDate(contract.lastPeriodEndDate)
                                                                ) :
                                                                    new Date(contract.lastPeriodEndDate).getMonth() === new Date().getMonth() &&
                                                                        new Date(contract.lastPeriodEndDate).getFullYear() === new Date().getFullYear() ? (
                                                                        // If the month and year of lastPeriodEndDate equal the current month and year, display "Dernier mois !"
                                                                        'Dernier mois !'
                                                                    ) : (
                                                                        // Otherwise, calculate the remaining time in months
                                                                        (() => {
                                                                            const endDate = new Date(contract.lastPeriodEndDate);
                                                                            const currentDate = new Date();
                                                                            const diffInMonths =
                                                                                (endDate.getFullYear() - currentDate.getFullYear()) * 12 +
                                                                                (endDate.getMonth() - currentDate.getMonth());
                                                                            return `${diffInMonths} mois${diffInMonths > 1 ? '' : ''}`;
                                                                        })()
                                                                    )}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                }
                                                <Box className='contractMachine_gridview_icon_title_response_box'>
                                                    <Iconify icon={"iconoir:washing-machine"} width="20px" />
                                                    <Box className='contractMachine_gridview_response_box'>
                                                        <Typography className='contractMachine_gridview_text_label'>Machines liées :</Typography>
                                                        <Box className="ships_box">
                                                            <Typography className="ships_label">{uniqueMachineIds.size} machines</Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                                <Box className='contractMachine_gridview_machine_footer_Box'>
                                                    <ContractRenewStatus status={contract.auto_renew} />
                                                </Box>
                                            </CardContent>
                                        </>
                                    ) : (
                                        <>
                                            <Skeleton variant="rectangular" height={192} />
                                            <CardContent className='contractMachine_gridview_card_CardContent'>
                                                <Skeleton variant="text" />
                                                <Skeleton variant="text" />
                                                <Skeleton variant="text" />
                                                <Box className='contractMachine_gridview_machine_footer_Box'>
                                                    <Skeleton variant="text" />
                                                    <Skeleton variant="text" />
                                                </Box>
                                            </CardContent>
                                        </>
                                    )}
                                </CardActionArea>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
});

export default MachineContractCardViewData;